import { EXPERIENCE_RESOURCE_REGISTRY as BASE_RESOURCE_REGISTRY, } from './resource-registry.js';
import { getAdminResourceDescriptor } from '../admin/released-admin-resource.registry.js';
import { ORGANIZATION_REGULATORY_PROFILE_FORM } from './organization-regulatory-profile-form.js';
import { MARKET_PRICE_CREATE_FORM, MARKET_PRICE_EDIT_FORM, MARKET_PRICE_VIEW_FORM, } from './market-price-form-descriptors.js';
import { SETTLEMENT_INSTRUCTION_FORM } from './settlement-descriptors.js';
import { POSITION_TRANSFER_WORKFLOW_FORM } from './position-transfer-descriptors.js';
import { ICON_IDS } from '../routes/ids.js';
const platformUsers = Object.freeze({
    ...BASE_RESOURCE_REGISTRY['platform-users'],
    createFormDescriptorId: 'form.admin.platformUser.create',
    editFormDescriptorId: 'form.admin.platformUser.edit',
    viewFormDescriptorId: 'form.admin.platformUser.view',
    bespokeReason: undefined,
});
const platformModules = Object.freeze({
    ...BASE_RESOURCE_REGISTRY['platform-modules'],
    createTitleKey: 'form.platformModuleAssignment.createTitle',
    createFormDescriptorId: 'form.admin.platformModuleAssignment.create',
    editTitleKey: 'page.moduleAssignments.title',
    editFormDescriptorId: 'form.admin.platformModuleAssignment.edit',
    bespokeReason: undefined,
});
const platformAudit = Object.freeze({
    ...BASE_RESOURCE_REGISTRY['platform-audit'],
    bespokeReason: undefined,
});
const platformAccessInspector = Object.freeze({
    ...BASE_RESOURCE_REGISTRY['platform-access-inspector'],
    bespokeReason: undefined,
});
const supportDelegation = Object.freeze({
    ...BASE_RESOURCE_REGISTRY['platform-support-delegations'],
    createFormDescriptorId: 'form.admin.platformSupportDelegation.create',
    editFormDescriptorId: 'form.admin.platformSupportDelegation.revoke',
    viewFormDescriptorId: 'form.admin.platformSupportDelegation.view',
    bespokeReason: undefined,
});
const marketPrices = Object.freeze({
    ...BASE_RESOURCE_REGISTRY['market-prices'],
    createTitleKey: 'data:marketPrices.createTitle',
    editTitleKey: 'data:marketPrices.editTitle',
    detailTitleKey: 'data:marketPrices.detailTitle',
    descriptionKey: 'data:marketPrices.description',
    createFormDescriptorId: MARKET_PRICE_CREATE_FORM.id,
    editFormDescriptorId: MARKET_PRICE_EDIT_FORM.id,
    viewFormDescriptorId: MARKET_PRICE_VIEW_FORM.id,
    rowActivationField: 'id',
    readOnly: false,
    bespokeReason: undefined,
});
const settlementInstructions = Object.freeze({
    ...BASE_RESOURCE_REGISTRY['settlement-instructions'],
    createFormDescriptorId: SETTLEMENT_INSTRUCTION_FORM.id,
});
const positionTransfers = Object.freeze({
    ...BASE_RESOURCE_REGISTRY['position-transfers'],
    createFormDescriptorId: POSITION_TRANSFER_WORKFLOW_FORM.id,
});
const regulatoryProfileResource = getAdminResourceDescriptor('organization-regulatory-profile');
if (!regulatoryProfileResource) {
    throw new Error('Released organization regulatory profile resource is missing');
}
const organizationRegulatoryProfile = Object.freeze({
    ...regulatoryProfileResource,
    id: regulatoryProfileResource.id,
    listTitleKey: 'organization.regulatoryProfile.title',
    editTitleKey: 'organization.regulatoryProfile.title',
    detailTitleKey: 'organization.regulatoryProfile.title',
    descriptionKey: 'organization.regulatoryProfile.description',
    iconKey: ICON_IDS.SECURITY,
    i18nNamespace: 'admin',
    editFormDescriptorId: ORGANIZATION_REGULATORY_PROFILE_FORM.id,
    viewFormDescriptorId: ORGANIZATION_REGULATORY_PROFILE_FORM.id,
    readOnly: false,
    bespokeReason: 'Singleton organization settings resource rendered by a generic form with the active organization identifier.',
});
export const EXPERIENCE_RESOURCE_REGISTRY = Object.freeze({
    ...BASE_RESOURCE_REGISTRY,
    'platform-users': platformUsers,
    'platform-modules': platformModules,
    'platform-audit': platformAudit,
    'platform-access-inspector': platformAccessInspector,
    'platform-support-delegations': supportDelegation,
    'market-prices': marketPrices,
    'settlement-instructions': settlementInstructions,
    'position-transfers': positionTransfers,
    'organization-regulatory-profile': organizationRegulatoryProfile,
});
export function getExperienceResourceDescriptor(resourceId) {
    return EXPERIENCE_RESOURCE_REGISTRY[resourceId];
}
